<template>
    <transition name="fade" mode="out-in" v-on:enter="ScrollToBottom(true)">
        <div class="chat-app" :class="{'is-widget' : iswidget}" v-if="chat !== null" :key="1">
            <div class="chat-messages-header">
                <div class="chat-header-info">
                    <label class="chat-title">
                        {{ chat.title }}
                    </label>
                    <label class="chat-start-date">
                        Conversa iniciada em: {{chat.data_inicio}}
                    </label>
                </div>
                <!--div class="chat-header-actions" v-on:contextmenu="mousedown(chat_id)" @contextmenu.prevent-->
                <div class="chat-header-actions" @click="mousedown(chat_id)">
                    <i class="fa fa-cog"></i>
                </div>
                <ul id="right-click-menu" tabindex="-1" v-if="viewMenu" v-focus v-on:blur="closeMenu()" v-bind:style="{ top: top, left: left }">
                    <li @click="pedido()" v-if="chat.extra.id_pedido" style="cursor:pointer"><i class="fa fa-eye"></i>&nbsp;&nbsp;Visualizar o pedido</li>
                    <li @click="arquivar()" style="cursor:pointer"><i class="fa fa-archive"></i>&nbsp;&nbsp;<span v-if="!mtipo">Arquivar</span><span v-if="mtipo">Desarquivar</span></li>
                </ul>
            </div>
            <div ref="chat" class="chat-messages-body" :class="{'atBottom' : options.atBottom}" v-on:scroll="CheckScrollBottom">
                <ul class="chat-messages-list list-unstyled">
                    <li v-for="message in messages" class="chat-message" :class="[message.sender]" :key="message.id">
                        <div class="chat-message-body" v-html="message.text"></div>
                        <div class="chat-message-attachment" v-if="message.attachment != null">
                            <a target="_blank" download :href="message.attachment" :title="message.attachment_title">
                                <i class="fa fa-paperclip"></i> {{  message.attachment_title }}
                            </a>
                        </div>
                        <div class="chat-message-adm clearfix" v-text="message.adm" style="margin-bottom: -5px"></div>
                        <time class="chat-message-time" v-text="message.time"></time>
                    </li>
                </ul>
            </div>
            <div ref="inputgroup" class="chat-input-group">
                <button @click.prevent="UploadFile" class="chat-action-button" :disabled="options.sending">
                    <i class="fa fa-paperclip"></i>
                </button>
                <textarea ref="input" maxlength="5000" class="chat-input" @input="ResizeInput" v-model="message" :readonly="options.sending" @keyup.ctrl.enter.exact="PushMessage" placeholder="Digite uma mensagem..."></textarea>
                <button class="chat-send-button" @click="PushMessage" :disabled="message.trim().length === 0 || options.sending" title="Enviar mensagem">
                    <i v-show="!options.sending || messagew == 'w'" class="fas fa-paper-plane fa-fw"></i>
                    <i v-show="options.sending  && messagew == ''"  class="spinner white"></i>
                </button>
            </div>
            <messenger-upload @upload="Refresh" :chat_id="chat_id" ref="upload"></messenger-upload>
        </div>
        <div v-else-if="chat === null" class="messenger-placeholder" :key="2">
            <span :class="['messenger-loading', options.isLoading ? 'isLoading' : '']">
                <i class="fa fa-comments"></i>
            </span>
            <div class="start-chat" v-if="id === null && newchatinfo !== null && !options.isLoading">
                <button type="button" @click="StartNewChat" class="btn btn-info">
                    <i class="fa fa-comment"></i> Iniciar novo chat
                </button>
            </div>
        </div>
    </transition>
</template>

<script>
    import m_upload from './messenger-upload';
    export default {
        name: "messenger",
        components: {
            "messenger-upload" : m_upload
        },
        props : {
            'chat_id' : Number,
            'iswidget' : {
                type: Boolean,
                default: false
            },
            'refreshevery' : {
                type: Number,
                default: 15000
            },
            'newchatinfo' : {
                type: Object,
                default: function(){
                    return null;
                }
            }
        },
        data : function(){
            return {
                id: null,
                chat : null,
                messages : [],
                message:   '',
                viewMenu: false,
                top: '0px',
                left: '0px',
                mtipo: 0,
                messagew: '',
                options : {
                    autoRefresh : true,
                    atBottom : true,
                    sending : false,
                    cancelTokens : {
                        refresh : null,
                        load : null
                    },
                    isLoading : false
                }
            };
        },
        mounted : function(){
            setInterval(this.Refresh, this.refreshevery);
        },
        updated : function(){
            this.$nextTick(function(){
                this.ScrollToBottom();
            })
        },
        methods : {
            Load : function(c_id){
                var $vm = this;
                $vm.options.isLoading = true;
                if ($vm.options.cancelTokens.load){
                    $vm.options.cancelTokens.load.cancel('cancelada');
                }
                if ($vm.options.cancelTokens.refresh){
                    $vm.options.cancelTokens.refresh.cancel('Requisição cancelada');
                }
                $vm.Unload();
                $vm.id = c_id;

                $vm.options.cancelTokens.load = axios.CancelToken.source();
                axios.get('/cliente/messenger/load_chat/' + this.id, {
                    cancelToken : $vm.options.cancelTokens.load.token
                }).then(function (response) {
                    $vm.options.isLoading = false;
                    if (response.data === false){
                        return $vm.Unload();
                    }
                    $vm.chat = response.data.chat || null;
                    $vm.messages = response.data.messages;
                    $vm.$emit('load');
                    $vm.Refresh();
                }).catch(function(e){
                    if (e.message == 'cancelada'){
                        console.warn('Requisição cancelada.');
                        return;
                    }
                    $vm.options.isLoading = false;
                });
            },
            Unload : function () {
                this.chat = null;
                this.messages = [];
                this.message = '';
                this.id = null;
                this.options.atBottom = true;
            },
            Refresh : function () {
                var $vm = this;
                if (!$vm.id || !$vm.chat) {
                    return;
                }
                if(messenger.arq){
                    this.messagew = 'w'; this.options.sending = true;
                }else{
                    this.messagew = ''; this.options.sending = false;
                }
                $vm.options.cancelTokens.refresh = axios.CancelToken.source();
                axios.get('/cliente/messenger/get_messages/' + $vm.id, {
                    cancelToken : $vm.options.cancelTokens.refresh.token
                }).then(function(response){
                    $vm.messages = response.data;
                    $vm.$emit('refresh');
                }).catch(function(){
                    console.warn('Requisição cancelada.');
                });
            },
            PushMessage : function(){
                var $vm = this;
                if ($vm.message.trim().length === 0 || $vm.options.sending) {
                    return;
                }
                $vm.options.sending = true;
                axios.post('/cliente/messenger/push_message/' + $vm.id, {
                    message : $vm.message
                }).then(function(response){
                    $vm.message = '';
                    $vm.messages = response.data;
                    $vm.$emit('messagesent');
                }).catch().then(function(){
                    $vm.options.sending = false;
                });
            },
            StartNewChat : function(){
                var $vm = this;
                $vm.options.isLoading = true;
                axios.post('/admin/messenger/start_new', {
                    info : this.newchatinfo
                }).then(function(response){
                    var data = response.data;
                    if (data.success){
                        $vm.Load(data.id);
                    }
                    else {
                        alert('Erro ao criar chat');
                    }
                });
            },
            CheckScrollBottom : function(e){
                var chat_el = this.$refs.chat;
                var scroll_offset = 10;
                this.options.atBottom = chat_el.scrollTop >= ((chat_el.scrollHeight - chat_el.offsetHeight) - scroll_offset);
            },
            ScrollToBottom : function(leave){
                var $chat_el = this.$refs.chat;
                if ($chat_el && this.options.atBottom){
                    $chat_el.scrollTop = $chat_el.scrollHeight;
                }
            },
            ResizeInput : function () {
                if (this.iswidget) return;
                var t_area = this.$refs.input;
                t_area.style.height = "1px";
                t_area.style.height = (t_area.scrollHeight)+"px";
                t_area.style.overflow = t_area.offsetHeight >= 100 ? 'auto' : 'hidden';
            },
            UploadFile : function(){
                this.$refs.upload.Open();
            },
            mousedown(id){
                this.mtipo = messenger.arq;
                this.viewMenu = true;
                var top = event.y;
                var left = event.x - 275;
                this.top = top + 'px';
                this.left = left + 'px';
                this.arqId = id;
            },
            closeMenu: function() {
                this.viewMenu = false;
            },
            pedido: function(){
                this.closeMenu();
                window.open('/cliente/pedidos/' + this.chat.extra.id_pedido, '_blank');
            },
            arquivar: function() {
                var $vm = this;
                axios.get('/cliente/messenger/arquivar', { params : {id: this.arqId, tipo: this.mtipo}})
                    .then(function(response){
                        $vm.chat = null;
                        $vm.options.isLoading = false;
                        $vm.isLoading = false;
                        messenger.AtualizarChats(true);
                    });
                $vm.closeMenu();
            }
        },
        watch : {
            messages : {
                handler : function(newVal, oldVal){
                    
                    if (newVal && (newVal.length !== (oldVal || []).length))
                        this.$emit('messageschanged');
                }
            },
            chat_id : {
                immediate : true,
                handler : function(value){
                    if (value !== null){
                        this.Load(value);
                    }
                    else{
                        this.Unload();
                    }
                }
            }
        },
        computed : {
            ShowMessengerLink : function(){
                return this.chat && (this.chat.type !== 'pedido_item');
            }
        }
    }
</script>

<style scoped lang="scss">
    $chat-blue: #0284fe;

    @keyframes spin {
        100% {
            -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
        }
    }


    .spinner{
        display: inline-block;
        border: 2px solid gray;
        border-bottom-color: transparent !important;
        border-right-color: transparent !important;
        border-radius: 50%;
        width: 20px;
        height: 20px;
        animation: fa-spin 0.7s linear infinite;
        &.white{
            border-color: white;
        }
    }
    
    @mixin flex-center() {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .messenger-placeholder {
        flex: 3;
        position: relative;
        @include flex-center;
        .messenger-loading {
            position: relative;
            width: 200px;
            height: 200px;
            border-radius: 50%;
            padding: 25px;
            color: #ccc;
            font-size: 7em;
            transition: all 0.4s ease;
            @include flex-center;
            font-family: FontAwesome, sans-serif;
            &:after {
                transition: all 0.3s ease;
                opacity: 0;
                content: ' ';
                border: 3px solid $chat-blue;
                border-right-color: transparent;
                border-bottom-color: transparent;
                box-shadow: 0 0 3px #ccc;
                border-radius: 50%;
                display: inline-block;
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                animation: spin 1s linear infinite;
            }
            &.isLoading {
                color: $chat-blue;
                animation: pulse 1000ms ease-in-out infinite;
                &:after {
                    opacity: 1;
                }
            }
        }

        .start-chat {
            position: absolute;
            background: rgba(255, 255, 255, 0.58);
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }

    .chat-app {
        flex: 3;
        display: flex;
        flex-direction: column;
        background: white;
        border-radius: 0 5px 5px 0;
        .chat-messages-header {
            display: flex;
            flex-direction: row;
            border-bottom: 1px solid #ccc;
            min-height: 60px;
            .chat-header-info {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .chat-title {
                    font-weight: bold;
                    font-size: 16px;
                    margin: 0;
                }
                .chat-start-date {
                    font-size: 13px;
                    color: #888;
                    margin-bottom: 0;
                }
            }
            .chat-header-actions {
                @include flex-center;
                width: auto;
                margin-left: auto;
                padding: 0 15px;
                border-left: 1px solid #ccc;
            }
        }
        .chat-app {
            display: flex;
            flex-direction: column;
        }
        .chat-messages-body {
            padding: 20px;
            flex: 1;
            overflow-y: auto;
            //region Scrollbar
            &::-webkit-scrollbar {
                background: white;
                width: 8px;
            }
            &::-webkit-scrollbar-track {
                background: #eee;
            }
            &::-webkit-scrollbar-thumb {
                background: $chat-blue;
                border-radius: 5px;
            }
            //endregion
            .chat-messages-list {
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                .chat-message {
                    padding: 5px 10px;
                    flex-direction: column;
                    color: white;
                    border-radius: 7px;
                    margin-top: 20px;
                    max-width: 45%;
                    white-space: pre-line;
                    &.other {
                        align-self: flex-start;
                        color: #0b090b;
                        background: #f1eff2;
                        border-bottom-left-radius: 3px;
                        > time {
                            float: left;
                            color: rgba(0, 0, 0, 0.7);
                        }
                        + .other {
                            margin-top: 10px;
                        }
                    }
                    &.self {
                        align-self: flex-end;
                        background: $chat-blue;
                        border-bottom-right-radius: 3px;
                        > time {
                            float: right;
                            color: rgba(255, 255, 255, 0.8);
                        }
                        + .self {
                            margin-top: 10px;
                        }
                    }
                    &.server {
                        width: 80%;
                        color: #444;
                        align-self: center;
                        background: #e2e2e2;
                        + .server {
                            margin-top: 10px;
                        }
                    }
                    time {
                        margin-top: 5px;
                        font-size: 11px;
                    }
                    .chat-attachment {
                        > a {
                            color: white;
                            text-decoration: underline;
                            font-size: 12px;
                        }
                    }
                }
            }
        }
        .chat-input-group {
            width: 100%;
            min-height: 65px;
            margin-top: auto;
            display: flex;
            flex-direction: row;
            padding: 5px;
            background: #f1eff2;
            border-top: 1px solid #ccc;
            position: relative;
            .chat-action-button{
                background: #f1eff2;
                font-size: 20px;
                display: flex;
                color: #aaa;
                border: 1px solid #aaa;
                border-radius: 10px;
                padding: 0 20px;
                margin: 5px 0;
                cursor: pointer;
                outline: none;
                &:hover, &:focus {
                    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
                    &:active {
                        background: #d5d3d6;
                    }
                }
                &:focus+.chat-actions{
                    visibility: visible;
                    opacity: 1;
                }
            }
            .chat-actions{
                opacity: 0;
                visibility: hidden;
                transition: all 0.2s ease;
                border: 1px solid #ccc;
                border-bottom: none;
                border-radius: 3px;
                position: absolute;
                top: 0;
                transform: translateY(-100%);
                overflow: hidden;
                ul{
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    flex-direction: column;
                    li{
                        padding: 10px 5px;
                        border-bottom: 1px solid #ccc;
                        &:hover{
                            background: $chat-blue;
                        }
                        &:hover a{
                            color: white;
                        }
                        a{
                            padding: 10px;
                            color: gray;
                        }
                    }
                }
            }
            .chat-input {
                flex: 1;
                resize: none;
                overflow: hidden;
                min-height: 45px;
                max-height: 300px;
                height: 45px;
                padding: 7px;
                margin: 5px;
                border-radius: 5px;
                box-shadow: none;
                transition: background 0.4s ease, color 0.4s ease;
                &::placeholder {
                    color: #aaa;
                }
                &:read-only {
                    background: #e2e2e2;
                    color: gray;
                }
            }
            .chat-send-button {
                background: $chat-blue;
                display: flex;
                border: none;
                color: white;
                border-radius: 10px;
                margin: 5px 10px;
                padding: 0 20px;
                cursor: pointer;
                outline: none;
                transition: background 0.4s ease;
                &:hover {
                    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.5);
                    &:active {
                        background: #026edc;
                    }
                }
                &:disabled {
                    background: #6ea8fe;
                }
            }
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .chat-message-adm{
        font-size: 10px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/loja/vue-components/messenger.vue